// Mapping of DICOM UIDs to their corresponding report IDs
const patientReports = {
  // Format: dicomUid: reportId
  '1.2.840.113619.2.261.4.2147483647.1719323884.764567': 1,  // Tanisha Lillard's report
  '1.2.840.113564.200.31.102.75.62.208.20201210124934329.1033': 2,  //cristine's report
  '1.2.840.113619.2.261.4.2147483647.1719323884.764569': 3,  // Robert Johnson's report
  '1.2.840.113619.2.261.4.2147483647.1719323884.764570': 4,  // Sarah Williams' report
  '1.2.840.113619.2.261.4.2147483647.1719323884.764571': 5,  // Michael Brown's report
};

export default patientReports; 